import KeyElementsDashboard from './KeyElementsDashboard';
import KeyElements from './KeyElements';

export {
  KeyElementsDashboard
}

export default KeyElements;
